import getWishlists from './getWishlists.js';
import CacheableResult from '../../../helpers/cache/CacheableResult.js';

const cachableWishlists = new CacheableResult(() => getWishlists(), 4000);

export default cachableWishlists.read.bind(cachableWishlists);
